// extracted by mini-css-extract-plugin
export default {"row":"styles_row__x98jn","rowCols3":"styles_rowCols3__jzCFU","col":"styles_col__4ioCW","half":"styles_half__uHyiK"};